const PROXY_URL = import.meta.env.VITE_PODCAST_PROXY_URL as string | undefined

// A 200 with a json/text body is almost always an error payload in disguise
// (e.g. a Lambda runtime error from the proxy), but some CDNs serve real mp3s
// with sloppy content-types, so only reject when the bytes aren't mp3 either.
const SUSPECT_CONTENT_TYPES = /^(application\/json|text\/)/i

function looksLikeMp3(head: Uint8Array): boolean {
  if (head.length >= 3 && head[0] === 0x49 && head[1] === 0x44 && head[2] === 0x33) return true
  return head.length >= 2 && head[0] === 0xff && (head[1] & 0xe0) === 0xe0
}

async function fetchAsBlob(url: string): Promise<Blob> {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const blob = await res.blob()
  const contentType = res.headers.get('content-type') ?? ''
  if (SUSPECT_CONTENT_TYPES.test(contentType)) {
    const head = new Uint8Array(await blob.slice(0, 3).arrayBuffer())
    if (!looksLikeMp3(head)) {
      const snippet = (await blob.slice(0, 200).text()).replace(/\s+/g, ' ').trim()
      throw new Error(`Expected audio but got ${contentType}: ${snippet}`)
    }
  }
  return blob
}

export async function fetchEpisodeAudio(url: string): Promise<Blob> {
  try {
    return await fetchAsBlob(url)
  } catch (err) {
    if (!PROXY_URL) throw err
    if (err instanceof TypeError) {
      return fetchAsBlob(`${PROXY_URL}?url=${encodeURIComponent(url)}`)
    }
    throw err
  }
}
